// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_95-0";
export var headerCellHover = "_95-1";
export var readCellContainer = "_95-2";
export var readCellSlot = "_95-3";
export var rowHoverCheckbox = "_95-4";
export var rowUnreadIndicator = "_95-5";
export var searchHighlight = "_95-8";
export var supportTicketRow = "_95-6";
export var unreadIndicator = "_95-7";